module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-8-04d074b1d6499107d3364567a4f241e1.png";